import * as actionTypes from '../../types/user';
import { history } from '../../../history';

/**
 * @function
 * @name userLogoutAction
 * @description Logout
 */
export const userLogoutAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.USER_AUTH_LOGOUT });
  return {};
};

/**
 * @function
 * @name userUnauthorizedAction
 * @description Ошибка токена, ставим лоадед и проверяем refreshToken
 */
export const userUnauthorizedAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.USER_AUTH_UNAUTHORIZED });
  return {};
};

/**
 * @function
 * @name userLogoutCredentialsAction
 * @description Делаем Logout и удаляем токены из localStorage
 */
export const userLogoutCredentialsAction = (error) => async (dispatch) => {
  window?.localStorage?.removeItem('access_token');
  dispatch({ type: actionTypes.USER_AUTH_LOGOUT_CREDENTIALS, payload: { error } });
  history.replace({ pathname: '/', search: history.location.search });
  return {};
};

/**
 * @function
 * @name userAuthLoader
 */
export const userAuthLoader = (isLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.USER_AUTH_LOADING, payload: { isLoading } });
  return {};
};

/**
 * @function
 * @name userAuthSuccess
 */
export const userAuthSuccess = (data) => async (dispatch) => {
  if (data?.access_token) {
    localStorage.setItem('access_token', data.access_token);
  }
  dispatch({ type: actionTypes.USER_AUTH_SUCCESS, payload: { data } });
  return {};
};

/**
 * @function
 * @name userRefreshSuccess
 */
export const userRefreshSuccess = (data) => async (dispatch) => {
  if (data?.access_token) {
    localStorage?.setItem('access_token', data.access_token);
  }
  dispatch({ type: actionTypes.USER_REFRESH_SUCCESS, payload: { data } });
  return {};
};

/**
 * @function
 * @name userAuthError
 */
export const userAuthError = (error) => async (dispatch) => {
  window?.localStorage?.removeItem('access_token');
  dispatch({ type: actionTypes.USER_AUTH_ERROR, payload: { error } });
  return {};
};

/**
 * @function
 * @name userAuthSuperAdminSuccess
 */
export const userAuthSuperAdminSuccess = (token) => async (dispatch) => {
  localStorage?.setItem('access_token', token);
  dispatch({
    type: actionTypes.USER_SUPER_ADMIN_AUTH_SUCCESS,
    payload: {
      token,
    },
  });
  return {};
};
